import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosClient from "../../axiosClient";
import { Loader } from "rsuite";
import { Question } from "../../types";
import ReadOnlyQuestionsView from "../Shared/ReadOnlyQuestionsView";

const ReviewPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [questions, setQuestions] = useState<Question[]>([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let subjectId = searchParams.get("subjectId");
    let moduleIds = searchParams.get("moduleIds");

    let queryParms = "?";
    if (subjectId) {
      queryParms += `subjectId=${subjectId}`;
    } else {
      queryParms += `moduleIds=${moduleIds}`;
    }

    const getQuestions = async () => {
      try {
        const submissionResp: {
          id: number;
          submittedDate: string;
          assignmentId: number;
          assignment: {
            name: string;
          };
          studentId: number;
          score: number;
          questions: Question[];
        } = (
          await axiosClient.get("/practice-questions-completed" + queryParms)
        ).data;

        setQuestions(submissionResp.questions);
        setIsLoading(false);
      } catch (error) {
        navigate("/dashboard");
      }
    };

    getQuestions();
  }, []);

  if (isLoading) {
    return <Loader size="md" content="Loading..." style={{ margin: "auto" }} />;
  }

  return (
    <ReadOnlyQuestionsView
      questions={questions}
      pageId="ReviewPage"
      onQuestionsUpdate={setQuestions}
    />
  );
};

export default ReviewPage;
